module.exports = __webpack_public_path__ + "img/24_16.38c1cf30.png";